<template>
  <input
    ref="datepicker"
    type="text"
    :value="value"
    :id="id"
    :name="name"
    :class="cssClass"
    :placeholder="placeholder"
    @input="updateValue($event.target.value)"
  >
</template>
<script>
  import Pikaday from 'pikaday'
  import { format } from 'date-fns'

  export default {
    props: [
      'id',
      'name',
      'value',
      'cssClass',
      'placeholder',
      'options',
      'disabledDays'
    ],

    data: () => ({
      datepicker: null
    }),

    mounted () {
      // @TODO: Add validation
      let config = {
        field: this.$refs.datepicker,
        format: 'YYYY-MM-DD',
        toString (date, dateFormat) {
          return format(date, dateFormat)
        },
        firstDay: 1,
        position: 'top left',
        yearRange: 100,
        showMonthAfterYear: true,
        onSelect: () => {
          this.$emit('input', this.datepicker.toString())
        },
        i18n: {
          previousMonth: 'Előző hónapő',
          nextMonth: 'Következő hónap',
          months: ['január', 'február', 'március', 'április', 'május', 'június', 'július', 'augusztus', 'szeptember', 'október', 'november', 'december'],
          weekdays: ['vasárnap', 'hétfő', 'kedd', 'szerda', 'csütörtök', 'péntek', 'szombat'],
          weekdaysShort: ['vas', 'hét', 'kedd', 'sze', 'csüt', 'pén', 'szo']
        },
        disableDayFn: date => {
          if (this.disabledDays && this.disabledDays.length) {
            return this.disabledDays.includes(date.getTime())
          }

          return false
        }
      }

      if (this.options && typeof this.options === 'object' && this.options !== null) {
        config = Object.assign(config, this.options)
      }

      this.datepicker = new Pikaday(config)
      if (config.defaultDate) {
        this.datepicker.setDate(config.defaultDate)
      }
    },

    beforeDestroy () {
      this.datepicker.destroy()
    },

    methods: {
      updateValue (value) {
        if (value === '') {
          this.$emit('input', '')
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Datepicker.vue?dcf8fb9a